import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
} from "@angular/router";
import { AzureSsoService } from "@app/core/auth";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
	constructor(private azureSsoService: AzureSsoService) {}

	canActivate(
		_route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean> {
		return this.azureSsoService.ensureAuthenticated(state.url);
	}
}
